module.exports = __webpack_public_path__ + "static/media/user.4d210af0.svg";